import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/loadingScreen.css";

const LoadingScreen = () => {
	const [showClickPrompt, setShowClickPrompt] = useState(false);
	const [currentLanguageIndex, setCurrentLanguageIndex] = useState(0);
	const [displayText, setDisplayText] = useState("");
	const [isDeleting, setIsDeleting] = useState(false);
	const [isTyping, setIsTyping] = useState(false);
	const [hintText, setHintText] = useState("");
	const [isHintAnimating, setIsHintAnimating] = useState(false);
	const [isFirstCycle, setIsFirstCycle] = useState(true);
	const navigate = useNavigate();

	const greetings = [
		"Hi, I'm Zhongkang",
		"你好，我是仲康",
		"你好，我係仲康",
		"Salut, je suis Zhongkang",
		"Hola, soy Zhongkang",
		"안녕하세요, 저는 중강이에요",
		"こんにちは、私は仲康です"
	];

	const hints = [
		"Click anywhere to continue",
		"点击任意位置继续",
		"點擊任意位置繼續",
		"Cliquez n'importe où pour continuer",
		"Haz clic en cualquier lugar para continuar",
		"아무 곳이나 클릭하여 계속하세요",
		"どこでもクリックして続けてください"
	];
	useEffect(() => {
		// Show click prompt after animation completes
		const timer = setTimeout(() => {
			setShowClickPrompt(true);
		}, 1500);

		return () => clearTimeout(timer);
	}, []);

	// Initialize with first greeting
	useEffect(() => {
		setDisplayText("");
		setIsTyping(true);
		setHintText(hints[0]); // Set initial hint text
	}, []);

	// Handle typewriter animation
	useEffect(() => {
		const currentGreeting = greetings[currentLanguageIndex];
		
		if (isDeleting) {
			if (displayText.length > 0) {
				const timer = setTimeout(() => {
					setDisplayText(displayText.slice(0, -1));
				}, 50);
				return () => clearTimeout(timer);
			} else {
				setIsDeleting(false);
				setIsTyping(true);
			}
		} else if (isTyping) {
			if (displayText.length < currentGreeting.length) {
				const timer = setTimeout(() => {
					setDisplayText(currentGreeting.slice(0, displayText.length + 1));
				}, 100);
				return () => clearTimeout(timer);
			} else {
				setIsTyping(false);
				// Update hint text when typing is complete and language changes
				// Skip animation on the very first time
				if (showClickPrompt && !isFirstCycle) {
					setIsHintAnimating(true);
					setTimeout(() => {
						setHintText(hints[currentLanguageIndex]);
						setIsHintAnimating(false);
					}, 300);
				}
				
				// Mark that we've completed the first cycle
				if (isFirstCycle) {
					setIsFirstCycle(false);
				}
				// Stay for 3 seconds after typing completes, then start deleting
				setTimeout(() => {
					setIsDeleting(true);
					setCurrentLanguageIndex((prevIndex) => 
						(prevIndex + 1) % greetings.length
					);
				}, 3000);
			}
		}
	}, [displayText, isDeleting, isTyping, currentLanguageIndex, greetings, hints, showClickPrompt]);

	useEffect(() => {
		// Language rotation is now handled in the typing completion logic above
	}, [greetings.length]);

	const handleClick = () => {
		navigate("/home");
	};

	return (
		<div className="loading-screen" onClick={handleClick}>
			<div className="loading-content">
				<div className="loading-logo">
					<img src="logo.png" alt="logo" className="logo-animation" />
				</div>
				<div className="loading-text">
					<h1 className="greeting-text">
						{displayText}
						<span className="cursor">|</span>
					</h1>
				</div>
				{showClickPrompt && (
					<div className={`click-prompt ${isHintAnimating ? 'animating' : ''}`}>
						<p>{hintText}</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default LoadingScreen;